import React from "react";

export const PlayIcon = () => (
  <svg viewBox="0 0 420 420">
    <path
      fill="#fff"
      d="M110 32c18-3 36 3 51 12l192 111c17 9 32 23 37 42 2 10 2 21-2 31-4 9-10 16-17 23-9 8-20 14-30 20L167 372c-14 8-30 15-46 15-12 1-24-2-33-10-11-9-17-22-20-36-2-10-2-20-2-30V100c0-17 3-34 13-48 7-11 19-18 31-20z"
    />
  </svg>
);

export const PauseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#fff"
    stroke="#fff"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="6" y="4" width="4" height="16" />
    <rect x="14" y="4" width="4" height="16" />
  </svg>
);

export const RefreshIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#111"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="1 4 1 10 7 10" />
    <polyline points="23 20 23 14 17 14" />
    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" />
  </svg>
);

export const DiceIcon = () => (
  <svg width="32" height="32" viewBox="0 0 512 512">
    <g fill="#111">
      <path d="M252.4 26.5c3.6-1.8 7.7-.6 11 1.2C326.5 62.5 390 97 453.1 131.7c4.2 2.2 6.7 6.6 6.4 11.3l-4.9 217c0 4-1.9 8.1-5.5 10.2L270.4 479.5c-4.6 2.6-8.9 6.5-14.4 6.9-5.3-.3-9.4-4-13.8-6.5L69.5 373.5c-4.3-2.7-10.1-5.2-10.7-11-.7-6.8-.5-13.6-.8-20.5l-5.6-198a12.2 12.2 0 017-12.6l184-100.1c3-1.6 5.9-3.5 9-4.8m0 26c-4.8 1-8.8 3.7-13 6-44.7 24.2-89.4 48.6-134 72.9-3.9 2.1-8 4-11.5 6.5-1.8 1.2-3.1 3.4-2.4 5.6.7 2.1 2.7 3.4 4.4 4.5l149.3 86.8a20.6 20.6 0 0020.5 0L409 152c3.7-2.3 8.1-3.9 11-7.4 2.1-3.1-.8-6.6-3.6-8l-148-81a22.7 22.7 0 00-16-3m-173 112.8c-2 .4-3.6 1.9-3.9 3.8-.8 4.8 0 9.7 0 14.6L80 342c0 7.4 4 14.6 10.4 18.5l144.8 89.1c2 1 4.3 2.3 6.6 1.3 2.8-1 3-4.4 3.1-7l-.5-166c0-4.9.4-10-1.7-14.6a21 21 0 00-9-10c-47.5-27.5-95-55-142.4-82.7-3.8-2-7.4-5.3-11.9-5.3m351 .1c-4.2 1.4-7.8 4-11.7 6.2l-141.4 81.7a20.6 20.6 0 00-10.8 15.7c-.4 5 0 10-.1 15 .1 52.6.4 105.3.4 158 .2 3-.3 6.8 2.6 8.8 2.4 1.5 5.2.2 7.5-1l145.8-89.2a22 22 0 0010.4-18.7l3.9-170c.5-3.7-2.6-8-6.6-6.5z" />
      <path d="M162.4 128.6c8.4-1.6 17.5-1 25.3 2.7 4.7 2.2 9.5 6.1 9.8 11.7 0 4.8-3.8 8.5-7.6 10.9a41.2 41.2 0 01-27.8 4c-6.3-1.3-12.9-4-16.6-9.5-2.3-3.3-2-8.1.7-11.2 3.9-5 10.1-7.4 16.2-8.6zM333.3 128.3c8.5-1.4 17.6-.7 25.3 3.2 4.3 2.1 8.6 5.6 9.2 10.6.5 4.7-3 8.7-6.6 11-7.7 5-17.3 6.2-26.2 5-7-1-14.4-3.5-18.8-9.3a9.5 9.5 0 010-11.4c4.1-5.4 10.8-7.8 17.1-9zM398.4 199.4c3.4-1 7.7-.8 10.3 2 3.9 3.6 4.4 9.3 3.8 14.3-1 7.3-4.2 14.3-8.6 20.2a29 29 0 01-17.2 11.7 9.7 9.7 0 01-10.5-5.8c-3-7-1-15 1.9-21.8 4-8.8 10.7-17.4 20.3-20.6zM106.3 210.2c5-1.6 10 .7 14 3.5 8.2 6 13.8 15 16 24.9 1.2 5.3 1.4 11.3-1.8 16-2.4 3.6-7.3 4.6-11.3 3.4a33.2 33.2 0 01-17.5-14.7c-4-6.7-7-14.4-6.4-22.2.2-4.5 2.5-9.4 7-10.9zM312.4 249.6c3.8-1.4 8.5-1.4 11.4 1.6 3.6 3.4 4.2 8.8 3.7 13.5a43 43 0 01-13 25.8c-4.2 3.9-9.6 7.3-15.5 7-4.5-.4-7.9-4.5-8.7-8.7-1.4-6.4.1-13 2.7-18.8 3.8-8.7 10.4-17 19.4-20.4zM398.6 258.7c3.7-1 8 0 10.4 3.3 3.5 4.6 3.3 10.8 2.2 16.2a43 43 0 01-15.5 24.5c-4 3-9.3 5.5-14.4 4-4.6-1.3-6.8-6.3-7.2-10.7a38.2 38.2 0 016.8-23.1 32.4 32.4 0 0117.7-14.2zM190.4 260.4c4.4-2 9.4-.4 13.2 2 8.3 5.2 14 13.8 17 23 1.7 6 2.6 12.9-.8 18.5-2.3 3.9-7.4 5.2-11.6 4a28.7 28.7 0 01-12.1-8 42.7 42.7 0 01-11.9-25.9c-.3-5 1.2-11.3 6.2-13.6zM107.4 307.4c4.3-1.6 9.1 0 12.9 2.3a42 42 0 0116.9 23c1.6 5.6 2.5 12-.2 17.3-1.7 3.7-5.9 6-10 5.5-6.6-1-12-5.4-16.2-10.3a42.9 42.9 0 01-10-24.2c-.3-5.2 1.4-11.4 6.6-13.6zM312.3 309.2c3.6-1.4 8-1.1 11 1.5 3.1 2.8 4 7.3 4 11.3a40 40 0 01-6.8 20.5c-3.8 6-9.3 11.4-16.1 13.9-4 1.5-9.4 1-12-2.8-4-5.4-3.3-12.8-1.5-19a39.2 39.2 0 0121.4-25.4zM396.4 318.5c3.9-1.3 8.8-.7 11.5 2.6 3.6 4.3 3.6 10.4 2.7 15.7-2 8.9-6.5 17.4-13.3 23.5-3.6 3-7.7 5.7-12.4 6.3-4.4.6-9-2-10.4-6.2-2.8-7.3-.7-15.5 2.5-22.4 4-8.4 10.4-16.3 19.4-19.5zM192.4 357.5c4.8-1.2 9.5 1.1 13.3 3.8a42.9 42.9 0 0116.2 26c1 5.1.8 11-2.4 15.2-2.9 3.8-8.4 4.3-12.6 2.5a37.6 37.6 0 01-18.7-19.3 35 35 0 01-3.6-17.7c.5-4.5 3-9.4 7.8-10.5zM314.4 368.6c3.6-.8 7.6.2 10 3 3.3 4.3 3.4 10.1 2.5 15.2a42.2 42.2 0 01-17.2 27c-4.2 2.7-10 4.7-14.7 2-4.8-2.6-5.8-8.8-5.5-13.8.7-8.2 4.1-16 9.2-22.4 4-5 9.3-9.6 15.8-11z" />
    </g>
  </svg>
);
